var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskCategoryOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#753f83;}.cls-3{mask:url(#mask);}.cls-4{fill:#aa5cbf;}.cls-5{mask:url(#mask-2-2);}.cls-6{fill:#d4a181;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-7{fill:#191847;}.cls-8{fill:#c1dee2;}.cls-9{fill:#89c5cc;}.cls-10{fill:#e4e4e4;}.cls-11{fill:#69a1ac;}.cls-12{fill-opacity:0.1;}.cls-13{fill-opacity:0.4;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -14,
    y: 0,
    width: 194,
    height: 140,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    className: "cls-1",
    width: 180,
    height: 140
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-2",
    x: 0,
    y: 0,
    width: 180,
    height: 140,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2-3",
    "data-name": "mask-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1-2",
    "data-name": "path-1",
    className: "cls-1",
    width: 180,
    height: 140
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "altro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "altro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 180,
    height: 140
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "cls-4",
    d: "M94.28,105C80,105,69.36,98.19,64.07,94A65.76,65.76,0,0,1,41,98.14c-30.38,0-55-20-55-44.57S10.62,9,41,9,96,29,96,53.57c0,10.63-4.6,20.36-12.25,28,2.69,10.8,11.67,20.42,11.78,20.53A1.72,1.72,0,0,1,94.28,105Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.08,20.49c-1.66,3.1-1.46,10.94.68,11.5.86.22,2.68-.32,4.54-1.44l-1.17,8.23H143l-2.37-11a7.73,7.73,0,0,0,2.07-5.58C142.28,16.05,133.74,17.4,132.08,20.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-7",
    d: "M135.81,17.48a10.64,10.64,0,0,0-4.14,1.11c0,1.82.35,2.36,3.37,2.32A5.41,5.41,0,0,1,137,22.86c-.26,3.66-1,5.5-2.09,5.5-1.69,0-3.13-1.08-3.87-1.08-.54,0-.42.68-.06,1.18s1.74.81,1.74,1.46c0,.32-.29.36-.57.36h-.21c-.2,0-.36,0-.36.16,0,.63-.2,1.82.89,1.82s4.29-.4,4.83-2a28.54,28.54,0,0,0,.68-6.59h.21a1.71,1.71,0,0,1,1.2,2.94c.4.56.85,1.15,1.36,1.76a5.76,5.76,0,0,0,1.46-7.76,4.24,4.24,0,0,0-3.08-2.83A5,5,0,0,0,135.81,17.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Leg",
    className: "cls-8",
    points: "143.59 62.55 129.52 98.13 120.08 128.21 116.35 128.21 130.78 62.55 143.59 62.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.42,62.55c.15,12.51,2.33,29.34,2.68,30.12q.36.78,24.11,19.82l-2.57,2.74q-28-16.32-29.32-18.5c-1.3-2.18-5.52-22.22-8.91-34.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe",
    className: "cls-10",
    d: "M175.33,112.43h0a13.9,13.9,0,0,1,1.56,1.65L166.5,126.47c-1.33-.57-1.75-1.24-1.25-2l1.22-1.92,2.06-7.21a1,1,0,0,1,1.24-.68h0l.5.16h0a5.23,5.23,0,0,0,1.77-1.18,2.68,2.68,0,0,0,.34-.57h0a1.89,1.89,0,0,1,2.51-.9A2.19,2.19,0,0,1,175.33,112.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Right-Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M122.09,128.74h0a14.62,14.62,0,0,1-.26,2.26H105.66c-.42-1.39-.18-2.14.73-2.25l2.25-.3,6.85-3a1,1,0,0,1,1.32.51v0l.2.49h0a5.15,5.15,0,0,0,2,.58,2.87,2.87,0,0,0,.65-.09h0a1.87,1.87,0,0,1,2.3,1.34A1.55,1.55,0,0,1,122.09,128.74Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Pant",
    className: "cls-11",
    points: "134.13 125.11 116.41 123.19 129.54 62.55 145.41 62.55 134.13 125.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.54,108.06,157.92,121.8q-18.36-20-21.41-26.14T131,62.55H148.9q1.32,23.76,1.79,24.86T169.54,108.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "cls-6",
    d: "M160.92,54.07l-5,.91q8.79,17.43,9.42,18.43c.93,1.5,0,4.21-.37,5.64a1.28,1.28,0,0,0,1.58-.75l.15-.23a1.7,1.7,0,0,1,2.21-.95c2.4.64,4.41,2.21,6.69.18.29-.25.5-1-.43-1.47-2.33-1-5.76-3-6.31-3.77q-1.12-1.53-7.89-18Zm-41.38,2.79-9.15,6.71a24.39,24.39,0,0,0-6.21,2.5c-.39.35-.87,1.08.76,1s3.35-.18,3.58.37-.77,1.22-.31,2q.45.75,4.29-3.75l9.06-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Back-Arm",
    className: "cls-11",
    d: "M136.06,33.07a72.76,72.76,0,0,1-18.65,24.52,9.78,9.78,0,0,0-3.83.58,1.27,1.27,0,0,0-.81,1.63,1.25,1.25,0,0,0,.8.8l-.8.57,2.31,4.71c9.71-4.84,18.83-8.48,23-16.46,1.12-2.16,1-8.48,1-12.59v-.72c0-.69,0-1.3,0-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-7",
    d: "M149.89,65.11q-13.51,1.47-21.28,0c-.64-.13-.61-2.89-.31-3.64C132.93,49.72,136,41.13,136,33c.85.44,2.34.51,4.46.2C146.14,41.58,148.77,51.22,149.89,65.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Front",
    className: "cls-9",
    d: "M139.47,32.48c1,12.68-12.29,40.37-7.69,64,8.51,1.89,20.66-4,32.48.71-.25-5.47-3.26-11.48-6.43-17.5l-.68-1.29a86.8,86.8,0,0,1-5.58-11.93,1.29,1.29,0,0,0,.4-1l0-.13h0l-.14-.84a1.29,1.29,0,0,0-1.12-1.06c-.1-.43-.18-.86-.25-1.28-.58-3.58.41-7.09.36-10.54q6.91,5.89,12.41,20.36h0l5.41-1.59c-.2-.77-.42-1.53-.64-2.28.63-.35,1.36-2,.83-2.25a6.15,6.15,0,0,0-1.72-.59q-7.46-22.41-24.36-32.78h-3.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shade-Lapel",
    className: "cls-12",
    points: "141.55 32.77 143.03 37.31 140.05 40.72 142.74 43.4 136.23 54.53 144.19 43.42 141.55 40.72 144.19 37.71 141.55 32.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Buttons",
    className: "cls-13",
    d: "M136.42,69.71a1.15,1.15,0,1,0,1.15,1.15A1.16,1.16,0,0,0,136.42,69.71Zm.29-6.58a1.15,1.15,0,1,0,1.14,1.14A1.14,1.14,0,0,0,136.71,63.13Zm1.43-6.59a1.15,1.15,0,1,0,1.15,1.15A1.15,1.15,0,0,0,138.14,56.54Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskCategoryOther);
export default __webpack_public_path__ + "static/media/ask-category-other.7f47392c11f72afdf736fa5aef5c07d6.svg";
export { ForwardRef as ReactComponent };